const config = {
  API_URL: process.env.REACT_APP_API_URL || '',
  captchaKey: process.env.REACT_APP_CAPTCHA_KEY || ''
};

export default config;